import React from 'react';
import Brokoli from '../../../assets/images/brokoli-square.png';
import ButtonOutlineGray from '../../misc/ButtonOutlineGray';
import ButtonGreen from '../../misc/ButtonGreen';

const Finish = () => {
  return (
    <>
      {/* Items Order */}
      <div className="flex flex-col py-4 my-1 border-b border-gray-200 text-font-gray capitalize items-start">
        <h5 className="text-lg text-font-gray opacity-50">#AG191ASD355</h5>
        <p className="text-font-gray text-sm">16 Agu 2020, 20.00 wib </p>
        <div className="flex w-full mt-2 -mx-2 my-2">
          <div className="flex ">
            <span className="mx-2 flex border border-gray-300 rounded">
              <div className="relative">
                <img src={Brokoli} alt="Brokoli" className="h-24 w-24 m-2" />
              </div>
            </span>
            <span className=" mx-2 flex border border-gray-300 rounded">
              <span className="relative ">
                <span className=" absolute  h-full w-full flex items-center justify-center">
                  <div className=" absolute h-full w-full bg-gray-500 opacity-50 "></div>
                  <p className=" absolute text-5xl text-white opacity-100 z-10">
                    +6
                  </p>
                </span>
                <img src={Brokoli} alt="Brokoli" className="h-24 w-24 m-2" />
              </span>
            </span>
          </div>
          <div className="flex flex-col mx-4 justify-between">
            <p className="text-font-gray">Pengantaran :</p>
            <div className="flex flex-col ">
              <p className="text-font-gray text-lg font-light">
                Besok, 17 Agu 2020{' '}
              </p>
              <p className="text-font-gray text-lg font-semibold">
                08.00-09.00
              </p>
            </div>
          </div>
          <div className="flex ml-auto flex-col justify-between items-end">
            <div className="flex">
              <ButtonOutlineGray text="base" addClass="mx-4">
                Rincian Pesanan
              </ButtonOutlineGray>
              <ButtonGreen>Diterima</ButtonGreen>
            </div>
            <div className="flex text-font-gray">
              <p>Total Pesanan :</p>
              <p className="font-semibold ml-4">Rp222.000</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Items Order */}
      {/* Items Order */}
      <div className="flex flex-col py-4 my-1 border-b border-gray-200 text-font-gray capitalize items-start">
        <h5 className="text-lg text-font-gray opacity-50">#AG191ASD355</h5>
        <p className="text-font-gray text-sm">16 Agu 2020, 20.00 wib </p>
        <div className="flex w-full mt-2 -mx-2 my-2">
          <div className="flex ">
            <span className="mx-2 flex border border-gray-300 rounded">
              <div className="relative">
                <img src={Brokoli} alt="Brokoli" className="h-24 w-24 m-2" />
              </div>
            </span>
            <span className=" mx-2 flex border border-gray-300 rounded">
              <span className="relative ">
                <span className=" absolute  h-full w-full flex items-center justify-center">
                  <div className=" absolute h-full w-full bg-gray-500 opacity-50 "></div>
                  <p className=" absolute text-5xl text-white opacity-100 z-10">
                    +6
                  </p>
                </span>
                <img src={Brokoli} alt="Brokoli" className="h-24 w-24 m-2" />
              </span>
            </span>
          </div>
          <div className="flex flex-col mx-4 justify-between">
            <p className="text-font-gray">Pengantaran :</p>
            <div className="flex flex-col ">
              <p className="text-font-gray text-lg font-light">
                Besok, 17 Agu 2020{' '}
              </p>
              <p className="text-font-gray text-lg font-semibold">
                08.00-09.00
              </p>
            </div>
          </div>
          <div className="flex ml-auto flex-col justify-between items-end">
            <div className="flex">
              <ButtonOutlineGray text="base" addClass="mx-4">
                Rincian Pesanan
              </ButtonOutlineGray>
              <ButtonGreen>Diterima</ButtonGreen>
            </div>
            <div className="flex text-font-gray">
              <p>Total Pesanan :</p>
              <p className="font-semibold ml-4">Rp222.000</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Items Order */}
      {/* Items Order */}
      <div className="flex flex-col py-4 my-1 border-b border-gray-200 text-font-gray capitalize items-start">
        <h5 className="text-lg text-font-gray opacity-50">#AG191ASD355</h5>
        <p className="text-font-gray text-sm">16 Agu 2020, 20.00 wib </p>
        <div className="flex w-full mt-2 -mx-2 my-2">
          <div className="flex ">
            <span className="mx-2 flex border border-gray-300 rounded">
              <div className="relative">
                <img src={Brokoli} alt="Brokoli" className="h-24 w-24 m-2" />
              </div>
            </span>
            <span className=" mx-2 flex border border-gray-300 rounded">
              <span className="relative ">
                <span className=" absolute  h-full w-full flex items-center justify-center">
                  <div className=" absolute h-full w-full bg-gray-500 opacity-50 "></div>
                  <p className=" absolute text-5xl text-white opacity-100 z-10">
                    +6
                  </p>
                </span>
                <img src={Brokoli} alt="Brokoli" className="h-24 w-24 m-2" />
              </span>
            </span>
          </div>
          <div className="flex flex-col mx-4 justify-between">
            <p className="text-font-gray">Pengantaran :</p>
            <div className="flex flex-col ">
              <p className="text-font-gray text-lg font-light">
                Besok, 17 Agu 2020{' '}
              </p>
              <p className="text-font-gray text-lg font-semibold">
                08.00-09.00
              </p>
            </div>
          </div>
          <div className="flex ml-auto flex-col justify-between items-end">
            <div className="flex">
              <ButtonOutlineGray text="base" addClass="mx-4">
                Rincian Pesanan
              </ButtonOutlineGray>
              <ButtonGreen>Diterima</ButtonGreen>
            </div>
            <div className="flex text-font-gray">
              <p>Total Pesanan :</p>
              <p className="font-semibold ml-4">Rp222.000</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Items Order */}
    </>
  );
};

export default Finish;
